<template>
  <Page>
    <div>
      <h1 class="page-header-1 mb-4">Marketplace</h1>
      <div class="d-flex marketplace-content">
        <CallRailMarketplaceCard />
        <FeatureFlag feature="camp_digital">
          <CampDigitalMarketplaceCard ref="camp_digital" />
        </FeatureFlag>
        <GPIMarketplaceCard />
        <FeatureFlag feature="jbw_enabled">
          <JBWarrantiesMarketplaceCard />
        </FeatureFlag>
        <PulseMMarketplaceCard />
        <FeatureFlag feature="qbo_direct">
          <QuickbooksMarketplaceCard ref="qbo" />
        </FeatureFlag>
        <FeatureFlag feature="ringcentral_ff_enabled">
          <RingCentralMarketplaceCard />
        </FeatureFlag>
        <FeatureFlag feature="financing">
          <ServiceFinanceMarketplaceCard />
        </FeatureFlag>
        <FeatureFlag feature="stax_payments">
          <StaxPaymentsMarketplaceCard />
        </FeatureFlag>
        <ZapierMarketplaceCard />
      </div>
    </div>
  </Page>
</template>

<script>
import { mapActions } from "vuex";
import { getQueryVariables } from "@/lib/url";

import Card from "@/components/Card.vue";
import FeatureFlag from "@/components/FeatureFlag.vue";
import Page from "@/components/Page.vue";
import CampDigitalMarketplaceCard from "@/Marketplace/CampDigitalMarketplaceCard.vue";
import StaxPaymentsMarketplaceCard from "@/Marketplace/StaxPaymentsMarketplaceCard.vue";
import CallRailMarketplaceCard from "./CallRailMarketplaceCard.vue";
import GPIMarketplaceCard from "./GPIMarketplaceCard.vue";
import JBWarrantiesMarketplaceCard from "./JBWarrantiesMarketplaceCard.vue";
import PulseMMarketplaceCard from "./PulseMMarketplaceCard.vue";
import QuickbooksMarketplaceCard from "./QuickbooksMarketplaceCard.vue";
import RingCentralMarketplaceCard from "./RingCentralMarketplaceCard.vue";
import ServiceFinanceMarketplaceCard from "./ServiceFinanceMarketplaceCard.vue";
import ZapierMarketplaceCard from "./ZapierMarketplaceCard.vue";

export default {
  components: {
    CampDigitalMarketplaceCard,
    Card,
    Page,
    FeatureFlag,
    CallRailMarketplaceCard,
    PulseMMarketplaceCard,
    ZapierMarketplaceCard,
    GPIMarketplaceCard,
    JBWarrantiesMarketplaceCard,
    RingCentralMarketplaceCard,
    StaxPaymentsMarketplaceCard,
    ServiceFinanceMarketplaceCard,
    QuickbooksMarketplaceCard
  },
  props: {
    tenantId: { type: Number, default: null }
  },
  async mounted() {
    await this.fetchPaymentMethodsSettings();

    const queryVariables = getQueryVariables();

    if (queryVariables.card) {
      const card = queryVariables.card;

      // VueJS does not have refs ready on mounted() for
      // components inside a v-if - which FeatureFlag ones are
      for (let i = 0; i < 5; i++) {
        if (this.$refs[card]) {
          try {
            this.$refs[card].openModal();
          } catch (e) {
            console.log(e.message);
          }
          break;
        }

        await this.$nextTick();
        await new Promise((r) => setTimeout(r, 200));
      }
    }
  },
  methods: {
    ...mapActions(["fetchPaymentMethodsSettings"])
  }
};
</script>

<style lang="scss" scoped>
.marketplace-content {
  display: flex;
  flex-wrap: wrap;
}
</style>
